import { render } from "./Top.vue?vue&type=template&id=08d6814e"
import script from "./Top.vue?vue&type=script&lang=js"
export * from "./Top.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v2/MaintenancePack/Top.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "08d6814e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('08d6814e', __exports__)) {
    api.reload('08d6814e', __exports__)
  }
  
  module.hot.accept("./Top.vue?vue&type=template&id=08d6814e", () => {
    api.rerender('08d6814e', render)
  })

}


export default __exports__